import { getValidationResult } from './index';

const USER = {
	USERNAME_MIN_LENGTH: 10,
	USERNAME_MAX_LENGTH: 10,
	NAME_MIN_LENGTH: 2,
	NAME_MAX_LENGTH: 12,
	PASSWORD_MIN_LENGTH: 6,
	EMAIL_PATTERN: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
};

const ERROR_MESSAGES = {
	USER: {
		USERNAME: `کد ملی معتبر نمی باشد`,
		USERNAME_REQUIRED: 'نام کاربری اجباری می باشد',
		NAME: `نام باید به طول حداقل  ${USER.NAME_MIN_LENGTH} وحداکثر ${USER.NAME_MAX_LENGTH} کاراکتر باشد`,
		NAME_REQUIRED: 'نام اجباری می باشد',
		PASSWORD_REQUIRED: 'رمزعبور اجباری می باشد',
		PASSWORD_LENGTH: `رمزعبور باید حداقل ${USER.PASSWORD_MIN_LENGTH} کاراکتر باشد`,
		PASSWORDS_NOT_MATCH: 'رمزعبورها با هم مطابقت ندارد',
		CONFIRM_PASSWORD_REQUIRED: 'تکرار رمزعبور مطابقت ندارد',
		EMAIL: 'ایمیل معتبر نمی باشد',
		EMAIL_REQUIRED: 'ایمیل اجباری می باشد',
		MOBILE_REQUIRED: 'شماره موبایل اجباری می باشد',
		MOBILE_INVALID: 'شماره موبایل نامعتبر می باشد'
	}
};

export const validateUsername = ({ username }) => {
	if (!username) {
		return getValidationResult(false, ERROR_MESSAGES.USER.USERNAME_REQUIRED);
	}

	const isValid = username.length >= USER.USERNAME_MIN_LENGTH && username.length <= USER.USERNAME_MAX_LENGTH;
	return getValidationResult(isValid, ERROR_MESSAGES.USER.USERNAME);
};


export const validateMobile = ({ mobile }) => {
	if (!mobile) {
		return getValidationResult(false, ERROR_MESSAGES.USER.MOBILE_REQUIRED);
	}

	const isValid = mobile.length === 11;
	return getValidationResult(isValid, ERROR_MESSAGES.USER.MOBILE_INVALID);
};

export const validateEmail = ({ Email }) => {
	if (!Email) {
		return getValidationResult(false, ERROR_MESSAGES.USER.EMAIL_REQUIRED);
	}
	const isValid = !!Email.match(USER.EMAIL_PATTERN);
	return getValidationResult(isValid, ERROR_MESSAGES.USER.EMAIL);
};

export const validatePassword = ({ password }) => {
	if (!password) {
		return getValidationResult(false, ERROR_MESSAGES.USER.PASSWORD_REQUIRED);
	}
	const isValid = password.length >= USER.PASSWORD_MIN_LENGTH;
	return getValidationResult(isValid, ERROR_MESSAGES.USER.PASSWORD_LENGTH);
};

export const validateConfirmPassword = ({ password, confirmPassword }) => {
	if (!confirmPassword) {
		return getValidationResult(false, ERROR_MESSAGES.USER.CONFIRM_PASSWORD_REQUIRED);
	}

	const isValid = !password ? false : password === confirmPassword;
	return getValidationResult(isValid, ERROR_MESSAGES.USER.PASSWORDS_NOT_MATCH);
};
export const validateFirstName = ({ firstName }) => validateName(firstName);
export const validateLastName = ({ lastName }) => validateName(lastName);

const validateName = (name) => {
	if (!name) {
		return getValidationResult(false, ERROR_MESSAGES.USER.NAME_REQUIRED);
	}
	const isValid = name.length >= USER.NAME_MIN_LENGTH && name.length <= USER.NAME_MAX_LENGTH;
	return getValidationResult(isValid, ERROR_MESSAGES.USER.NAME);
};
